import { render, staticRenderFns } from "./CollectionDetailTabBudget.vue?vue&type=template&id=e8b708fe&"
import script from "./CollectionDetailTabBudget.vue?vue&type=script&lang=ts&"
export * from "./CollectionDetailTabBudget.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionDetailTabBudget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
